import { CareerId } from '@common/const/catalog/career';
import { enumKeysToArray } from '@cp/utils/common/enumKeysToArray';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { FormAvailableOnlyFieldName } from 'src/entities/catalog/ui/availableOnly/model';
import { FORM_FIELDS_BASE, FORM_FIELDS_FOR_CAREER, FormFieldName } from '../form';

export const getFieldNames = ({
  catalogType,
  careerId,
}: {
  catalogType: CatalogItemType;
  careerId: CareerId;
}): (FormFieldName | FormAvailableOnlyFieldName)[] => {
  const fieldNames: FormFieldName[] = [...FORM_FIELDS_BASE];
  const fieldNamesForCareer = FORM_FIELDS_FOR_CAREER[catalogType][careerId];
  const faofNames = enumKeysToArray(FormAvailableOnlyFieldName).map((key) => FormAvailableOnlyFieldName[key]);

  if (fieldNamesForCareer) {
    fieldNames.push(...fieldNamesForCareer);
  }

  return [...fieldNames, ...faofNames];
};
